// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"A3-z","displaySixCardTiles":"B3-z"};